import HttpService from './HttpService';

import * as CONNECTION from '../Constants/Connection';

class DocumentService extends HttpService {
  getDocumentsList = async (damPath: string, pageIndex: number) => {
    const getDocumentsApiUrl =
      `${CONNECTION.CONTENT}${CONNECTION.API_VERSION}${CONNECTION.RESOURCES}${damPath}&${CONNECTION.RESOURCES_PAGE_PARAM}${pageIndex}&${CONNECTION.RESOURCES_PAGE_SIZE_PARAM}50`;

    return super.get(getDocumentsApiUrl);
  }

  getNZFAPDocumentsList = async (pageIndex: number) => {
    return this.getDocumentsList(CONNECTION.NZFAPDOCUMENTSPATH, pageIndex);
  }

  getSingleDocument = async (docId: string) => {
    const getDocumentApiUrl =
      `${CONNECTION.CONTENT}${CONNECTION.API_VERSION}${CONNECTION.SINGLERESOURCE}${docId}`;
    return super.get(getDocumentApiUrl, {}, 'blob');
  }
}

export default DocumentService;
